module.exports = __webpack_public_path__ + "static/img/footer-menu-icon05-3.20fda408.svg";